import { baseURL, secretKey } from "./config";

// Moderasyon ekranları için sade bir istemci. Her istekte güncel token okunur —
// api.js'teki sürüm token'ı modül yüklenirken bir kez okuduğu için oturum
// yenilendiğinde eski token'la kalıyordu.
const authHeaders = () => ({
  "Content-Type": "application/json",
  key: secretKey,
  Authorization: sessionStorage.getItem("token") || "",
});

const request = async (path, options = {}) => {
  const res = await fetch(`${baseURL}${path}`, {
    ...options,
    headers: authHeaders(),
  });

  if (res.status === 401) {
    sessionStorage.clear();
    window.location.href = "/";
    return { status: false, message: "Oturum süresi doldu." };
  }

  try {
    return await res.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};

export const modApi = {
  liveStreams: () => request("moderation/liveStreams"),
  endStream: (id, reason) =>
    request(`moderation/endStream/${id}`, {
      method: "POST",
      body: JSON.stringify({ reason }),
    }),

  complaints: (solved = false) => request(`moderation/complaints?solved=${solved}`),
  resolveComplaint: (id, outcome) =>
    request(`moderation/complaints/${id}/resolve`, {
      method: "POST",
      body: JSON.stringify({ outcome }),
    }),

  banned: () => request("moderation/banned"),
  ban: (type, id, reason) =>
    request("moderation/ban", {
      method: "POST",
      body: JSON.stringify({ type, id, reason }),
    }),

  bannedWords: () => request("moderation/bannedWord"),
  addBannedWord: (word, action) =>
    request("moderation/bannedWord", {
      method: "POST",
      body: JSON.stringify({ word, action }),
    }),
  deleteBannedWord: (id) =>
    request(`moderation/bannedWord/${id}`, { method: "DELETE" }),

  logs: (limit = 150) => request(`moderation/logs?limit=${limit}`),
};

export default modApi;
